import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./shared";

const faqs = [
  { q: "Which areas do you serve?", a: "We proudly serve homes and businesses across Edmonton, AB and surrounding communities. Not sure if we reach you? Just give us a call." },
  { q: "Do you bring your own supplies?", a: "Yes! Our cleaners arrive fully equipped with all tools and eco-friendly products. If you'd prefer we use your own, simply let us know." },
  { q: "How do I get a price?", a: "Just call us at 587-783-1980. We'll ask a few quick questions about your space and give you a transparent flat-rate quote — no hidden fees." },
  { q: "Are your cleaners insured and vetted?", a: "Absolutely. Every member of our team is trained, background-checked and insured for your complete peace of mind." },
  { q: "What if I'm not happy with the clean?", a: "Your satisfaction is guaranteed. If anything isn't up to standard, let us know within 24 hours and we'll return to make it right." },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-white py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal className="text-center mb-14">
          <p className="text-sm uppercase tracking-[0.25em] text-pink-dark font-semibold mb-4">Good to Know</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-teal font-medium">
            Frequently asked questions
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-blush"
              >
                <AccordionTrigger className="text-left font-serif-display text-xl text-teal hover:text-pink-dark hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-teal-soft text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
